import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../contexts/authContext';
import './SettingsPage.css'; 

function SubscriptionPage() {
    const navigate = useNavigate();
    // const { currentUser } = useAuth();

    // const handleSubscribeClick = () => {
    //     if (!currentUser) {
    //         alert("로그인이 필요한 서비스입니다.");
    //         return;
    //     }

    //     // 🌟 하드코딩 제거! .env 파일에서 주소를 '딸깍' 가져옵니다.
    //     const POLAR_BASE_URL = process.env.REACT_APP_POLAR_CHECKOUT_URL;
        
    //     if (!POLAR_BASE_URL) {
    //         console.error("결제 링크가 설정되지 않았습니다. (.env 확인 필요)");
    //         alert("결제 시스템 준비 중입니다.");
    //         return;
    //     }

    //     // 웹훅에서 유저를 식별할 수 있도록 email과 uid를 URL 파라미터로 붙여서 보냅니다.
    //     const checkoutUrl = `${POLAR_BASE_URL}?customer_email=${encodeURIComponent(currentUser.email)}&client_reference_id=${currentUser.uid}`;
        
    //     window.location.href = checkoutUrl;
    // };

    // 기존 로직을 아래처럼 수정합니다.
    const handleSubscribeClick = () => {
        // Polar 결제로 넘어가는 로직을 임시로 막고 알림만 띄웁니다.
        alert("준비중입니다.");
    };

    return (
        <div className="settings-page-container">
            {/* 배경 별 애니메이션 */}
            <div id="bright-stars1"></div>
            <div id="bright-stars2"></div>
            <div id="bright-stars3"></div>

            {/* 상단 바 */}
            <div className="settings-top-bar">
                <button className="back-button-icon" onClick={() => navigate(-1)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="top-bar-title" style={{ fontWeight: 'bold' }}>TAIM PLUS 구독</div>
            </div>

            {/* paddingTop을 80px로 주어 상단 바에 가려지는 현상 해결! */}
            <main className="settings-main-content" style={{ padding: '80px 20px 40px', textAlign: 'center' }}>
                
                {/* 헤더 섹션 */}
                <div style={{ marginBottom: '35px' }}>
                    <h1 style={{ color: '#222', fontSize: '30px', marginBottom: '12px', fontWeight: '900', letterSpacing: '-0.5px' }}>
                        <span style={{ color: '#F5A623' }}>TAIM</span> PLUS
                    </h1>
                    <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', fontWeight: '500' }}>
                        기다림 없이, 제한 없이,<br />
                        원하는 대로.
                    </p>
                </div>

                {/* 기능 설명 카드 리스트 */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '40px' }}>
                    
                    {/* 기능 1 */}
                    <div style={{ backgroundColor: '#FFFFFF', padding: '22px', borderRadius: '16px', textAlign: 'left', boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid rgba(0,0,0,0.05)' }}>
                        <div style={{ fontSize: '22px', marginBottom: '10px' }}>💬</div>
                        <h3 style={{ color: '#333', fontSize: '17px', marginBottom: '6px', fontWeight: '700' }}>넉넉한 AI 대화 한도</h3>
                        <p style={{ color: '#777', fontSize: '14px', margin: 0, lineHeight: '1.5', wordBreak: 'keep-all' }}>
                            흐름이 끊길 걱정은 이제 그만! 한도 횟수 대폭 증가로 깊고 몰입감 있는 대화를 즐겨보세요.
                        </p>
                    </div>

                    {/* 기능 2 */}
                    <div style={{ backgroundColor: '#FFFFFF', padding: '22px', borderRadius: '16px', textAlign: 'left', boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid rgba(0,0,0,0.05)' }}>
                        <div style={{ fontSize: '22px', marginBottom: '10px' }}>⚡</div>
                        <h3 style={{ color: '#333', fontSize: '17px', marginBottom: '6px', fontWeight: '700' }}>프로필 생성 쿨타임 삭제</h3>
                        <p style={{ color: '#777', fontSize: '14px', margin: 0, lineHeight: '1.5', wordBreak: 'keep-all' }}>
                            다음 프로필 생성까지 걸리는 대기시간을 완전히 없앴습니다. 언제든 즉시 새로운 프로필을 생성하고 더 다양한 상대를 추천받아보세요.
                        </p>
                    </div>

                    {/* 기능 3 */}
                    <div style={{ backgroundColor: '#FFFFFF', padding: '22px', borderRadius: '16px', textAlign: 'left', boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid rgba(0,0,0,0.05)' }}>
                        <div style={{ fontSize: '22px', marginBottom: '10px' }}>🎯</div>
                        <h3 style={{ color: '#333', fontSize: '17px', marginBottom: '6px', fontWeight: '700' }}>프리미엄 성별 필터링</h3>
                        <p style={{ color: '#777', fontSize: '14px', margin: 0, lineHeight: '1.5', wordBreak: 'keep-all' }}>
                            내가 원하는 성별의 유저만 쏙쏙 추천받을 수 있습니다. 가장 빠르고 정확한 매칭을 경험해 보세요.
                        </p>
                    </div>

                </div>

                {/* 결제 버튼 섹션 (블랙 카드로 프리미엄 느낌 강조) */}
                <div style={{ backgroundColor: '#2C2C2E', padding: '30px 20px', borderRadius: '20px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' }}>
                    <div style={{ fontSize: '28px', fontWeight: '900', color: '#FFF', marginBottom: '5px' }}>
                        ₩ 7,900 <span style={{ fontSize: '15px', color: '#AAA', fontWeight: '500' }}>/ 월 (VAT 별도)</span>
                    </div>
                    <p style={{ color: '#CCC', fontSize: '13px', marginBottom: '25px' }}>
                        커피 두 잔의 가격으로 누리는 무제한의 자유
                    </p>

                    <button 
                        onClick={handleSubscribeClick}
                        style={{
                            width: '100%',
                            padding: '16px',
                            backgroundColor: '#FFD700',
                            color: '#111',
                            fontWeight: '800',
                            fontSize: '17px',
                            border: 'none',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)'
                        }}
                    >
                        TAIM PLUS 시작하기
                    </button>

                    <div style={{ marginTop: '18px', color: '#888', fontSize: '11.5px', lineHeight: '1.5', wordBreak: 'keep-all' }}>
                        결제 시 자동으로 매월 정기 결제되며, 언제든 구독을 취소할 수 있습니다.<br/>
                        취소 시 다음 결제일부터 청구되지 않으며, 남은 기간 동안 혜택이 유지됩니다.
                    </div>
                </div>

            </main>
        </div>
    );
}

export default SubscriptionPage;